import ProjectWorld from '@/ProjectWorld';
import { injectable } from 'tsyringe';
import log from 'loglevel';

export const TOKEN_IProjectWorldCache = Symbol('IProjectWorldCache');

export interface IProjectWorldCache {
    isLoaded(projectId: string): boolean;
    unload(projectId: string): void;
    upsert(projectWorld: ProjectWorld): void;
    get(projectId: string): ProjectWorld;
}

@injectable()
export class ProjectWorldCache implements IProjectWorldCache {
    private worlds: Map<string, ProjectWorld> = new Map();

    upsert = (projectWorld: ProjectWorld): void => {
        this.worlds.set(projectWorld.projectMetadata.id, projectWorld);
    }

    isLoaded = (projectId: string): boolean => {
        return this.worlds.has(projectId);
    }

    unload(projectId: string): void {
        log.info("Unloading project with id: ", projectId);
        this.worlds.delete(projectId);
    }

    get(projectId: string): ProjectWorld {
        const item = this.worlds.get(projectId);

        if (!item) {
            throw new Error(`Project with ID "${projectId}" not found`);
        }

        return item;
    }
}
